import request from '@/utils/http';
const apiCrmHost = 'api-lcrm';

// 客户列表
export const getCustomerInfoPage = (data) => {
    return request({
        url: apiCrmHost + '/customer/info/page',
        method: 'post',
        data
    });
};
// 客户详情-zxh
export const getCustomerDetailInfo = (params) => {
    return request({
        url: apiCrmHost + '/customer/info/getById',
        method: 'get',
        params
    });
};
// 客户-签章人列表
export const getStamperInfoList = (data) => {
    return request({
        url: apiCrmHost + '/customer/stamper/info/page',
        method: 'post',
        data
    });
};
// 客户详情-签章人-启用-zxh
export const updateStamperStatus = (data) => {
    return request({
        url: apiCrmHost + '/customer/stamper/info/enableFlag',
        method: 'post',
        data
    });
};
// 客户详情-签章人-同步-rzq
export const syncStamperStatus = (data) => {
    return request({
        url: apiCrmHost + '/customer/stamper/sync/info',
        method: 'post',
        data
    });
};
// 客户-业务实体-新增
export const saveEbcaInfo = (data) => {
    return request({
        url: apiCrmHost + '/customer/account/save',
        method: 'post',
        data
    });
};
// 客户-业务实体
export const getEbcaInfoList = (data) => {
    return request({
        url: apiCrmHost + '/customer/account/query',
        method: 'post',
        data
    });
};
// 客户详情-删除-rzq
export const delEbcaStatus = (data) => {
    return request({
        url: apiCrmHost + '/customer/account/del',
        method: 'post',
        data
    });
};
// 客户详情-运维推送(产品专用)-rzq
export const pushEbcaStatus = (data) => {
    return request({
        url: apiCrmHost + '/customer/account/push/erp',
        method: 'post',
        data
    });
};
// 客户详情-业务主体-推送erp
export const pushInvalidEbcaStatus = (data) => {
    return request({
        url: apiCrmHost + '/customer/account/push/erp/invalid',
        method: 'post',
        data
    });
};

// 客户详情-确认-rzq
export const confirmEbcaStatus = (data) => {
    return request({
        url: apiCrmHost + '/customer/account/confirm',
        method: 'post',
        data
    });
};
// 客户详情-保存-
export const saveCustomer = (data) => {
    return request({
        url: apiCrmHost + '/customer/account/confirm',
        method: 'post',
        data
    });
};
// 客户详情-新建审批-
export const sumitFlowCustomer = (data) => {
    return request({
        url: apiCrmHost + '/customer/account/confirm',
        method: 'post',
        data
    });
};
// 客户详情-信息变更-
export const infoChangeCustomer = (data) => {
    return request({
        url: apiCrmHost + '/customer/account/confirm',
        method: 'post',
        data
    });
};
// 客户详情-状态变更-
export const statusChangeCustomer = (data) => {
    return request({
        url: apiCrmHost + '/customer/account/confirm',
        method: 'post',
        data
    });
};
// 客户详情-生成供应商-cyj
export const insertSupCustomer = (data) => {
    return request({
        url: apiCrmHost + '/customer/info/createSupplierByCustomerCode',
        method: 'post',
        data
    });
};
// 客户详情-新建虚拟客户-
export const insertVirCustomer = (data) => {
    return request({
        url: apiCrmHost + '/customer/account/confirm',
        method: 'post',
        data
    });
};
// 客户详情-同步集团-rzq
export const asyncGroupCustomer = (data) => {
    return request({
        url: apiCrmHost + '/customer/push/gcrm',
        method: 'post',
        data
    });
};
// 客户详情-同步法务-rzq
export const asyncLawCustomer = (data) => {
    return request({
        url: apiCrmHost + '/customer/push/fw',
        method: 'post',
        data
    });
};
// 客户详情-更新工商信息-yjl
export const updateBussinessCustomer = (data) => {
    return request({
        url: apiCrmHost + '/customer/util/tyc/baseInfo/update',
        method: 'post',
        data
    });
};
// 客户详情-获取风险等级-rzq
export const getRiskLevelCustomer = (data) => {
    return request({
        url: apiCrmHost + '/customer/account/confirm',
        method: 'post',
        data
    });
};
// 客户详情-运维解锁-cyj
export const opsUnlockCustomer = (data) => {
    return request({
        url: apiCrmHost + '/customer/account/confirm',
        method: 'post',
        data
    });
};
// 客户详情-运维保存-cyj
export const opsSaveCustomer = (data) => {
    return request({
        url: apiCrmHost + '/customer/account/confirm',
        method: 'post',
        data
    });
};
